import type { QueryDate } from '@/entities/query/types';
import dayjs from 'dayjs';

export const convertDate = (date?: string): QueryDate => {
  const _date = dayjs(date);
  return {
    year: _date.year(),
    month: _date.month() + 1,
    day: _date.date(),
  };
};
